import { useState, useEffect } from 'react';

export function useScrollDirection() {
    const [scrollDirection, setScrollDirection] = useState("up");

    useEffect(() => {
        let lastScrollY = window.pageYOffset;

        const updateScrollDirection = () => {
            const scrollY = window.pageYOffset;

            // Always show navbar at the very top
            if (scrollY < 10) {
                setScrollDirection("up");
                return;
            }

            const direction = scrollY > lastScrollY ? "down" : "up";

            //do zabawy albo lepiej to wogole jakos zrobic
            const threshold = direction === "down" ? 10 : 100; // Reduced up threshold for better responsiveness

            if (direction !== scrollDirection && Math.abs(scrollY - lastScrollY) > threshold) {
                setScrollDirection(direction);
                lastScrollY = scrollY > 0 ? scrollY : 0;
            } else if (direction === scrollDirection) {
                // Always update lastScrollY if moving in same direction
                lastScrollY = scrollY > 0 ? scrollY : 0;
            }
        };

        window.addEventListener("scroll", updateScrollDirection); // add event listener
        return () => {
            window.removeEventListener("scroll", updateScrollDirection); // clean up
        }
    }, [scrollDirection]);

    return scrollDirection;
}
